<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full gap-4 px-6">
    <div class="flex items-center justify-center rounded-full size-20 bg-n-alpha-2">
      <span class="i-lucide-message-circle size-10 text-n-slate-10" />
    </div>
    <span class="text-sm text-n-slate-12 font-medium text-center">
      {{ message }}
    </span>
  </div>
</template>
